// OK - Error CORS
// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

// const API_URL = "https://api.amigogroup.id/poin-vouchers/vouchers";
const API_URL =
  "https://backend." + Properties.DOMAIN_URL + "/poin-voucher/api/vouchers";

export default class VoucherPoinAPIService {
  constructor() {}
  config = this.$session.get("jwt");

  static getAll = (limit, page) =>
    apiClient.get(API_URL + "/limit/" + limit + "?page=" + page, {
    });
  static filter = (body, page) =>
    apiClient.get(API_URL + "/searching/filter-voucher?page=" + page, {
      params: body,
    });
  static filterOnPeriode = () =>
    apiClient.get(API_URL + "/filter/periode", {
      // params: body,
    });
  static getByID = (id) =>
    apiClient.get(API_URL + "/" + id, {
    });

  static edit = (id, voucher) =>
    apiClient.post(API_URL + "/" + id, voucher, {
    });
  static create = (voucher) =>
    apiClient.post(API_URL + "/", voucher, {
      "Content-Type": "multipart/form-data",
    });

  static delete = (id, nik) =>
    apiClient.delete(API_URL + "/" + id, {
      params: {
        user_update: nik,
      },
    });
}
